import { render, staticRenderFns } from "./Template-01.vue?vue&type=template&id=0548da04&scoped=true&"
import script from "./Template-01.vue?vue&type=script&lang=js&"
export * from "./Template-01.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./Template-01.vue?vue&type=style&index=1&lang=less&"
import style2 from "./Template-01.vue?vue&type=style&index=2&id=0548da04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0548da04",
  null
  
)

export default component.exports